import React, { Component } from "react";
import PropTypes from "prop-types";
import Loader from "../generic/Loading";
import logo from "../images/logo.svg";
import Input from "../generic/Input";
import queryString from "query-string";
import { updateModel } from "../data/Model";
import { requestAPI } from "../data/api";

class ChangePasswordScreen extends Component {
  constructor(props, context) {
    super(props, context);

    const routeValues = queryString.parse(this.props.location.search);

    this.state = {
      token: routeValues.token,
      password: "",
      repeatPassword: "",
      loading: false,
      errors: []
    };
  }

  changePassword = async () => {
    if (this.state.password !== this.state.repeatPassword) {
      this.setState({
        errors: [
          this.context.gettext(
            "changePassword.screen.errors.passwords_must_match"
          )
        ]
      });
      return;
    }

    this.setState({
      loading: true
    });

    const res = await requestAPI("/authentication/change-password", "POST", {
      password: this.state.password,
      token: this.state.token
    });

    if (res.status === "error") {
      this.setState({ errors: res.errors });
    } else {
      updateModel(model => (model.passwordChanged = true));
      this.props.history.push(`/`);
    }

    this.setState({
      loading: false
    });
  };

  render() {
    return (
      <div id="welcome-content">
        <div
          style={{
            opacity: this.state.loading ? 1 : 0,
            transform: this.state.loading
              ? "translateY(0px)"
              : "translateY(50px)"
          }}
          className="loading"
        >
          <Loader/>
        </div>
        <div
          style={{
            opacity: this.state.loading ? 0 : 1,
            transform: this.state.loading
              ? "translateY(-50px)"
              : "translateY(0px)"
          }}
          className="auth-box"
        >
          <img src={logo} className="logo" alt="logo"/>
          <h1 className="info-text">
            {this.context.gettext("changePassword.screen.info_text")}
          </h1>
          {this.state.errors.map(error => (
            <div className="warning">{error}</div>
          ))}
          <Input
            onChange={e => {
              this.setState({
                password: e.target.value
              });
            }}
            className="inp"
            type="password"
            value={this.state.password}
            placeholder={this.context.gettext(
              "changePassword.screen.placeholder.password"
            )}
          />
          <Input
            onKeyDown={e => {
              if (e.key === "Enter") this.changePassword();
            }}
            onChange={e => {
              this.setState({
                repeatPassword: e.target.value
              });
            }}
            className="inp"
            type="password"
            value={this.state.repeatPassword}
            placeholder={this.context.gettext(
              "changePassword.screen.placeholder.repeat_password"
            )}
          />
          <div className="d-flex has-spacing">
            <button
              className="btn full-width save-btn"
              onClick={this.changePassword}
              disabled={
                !this.state.password ||
                !this.state.repeatPassword ||
                this.state.loading
              }
            >
              {this.context.gettext("changePassword.screen.save_button")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ChangePasswordScreen.contextTypes = {
  gettext: PropTypes.func.isRequired,
};

export default ChangePasswordScreen;
